import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalModule } from 'ngx-bootstrap';
import { RequisitionCardActionsModalComponent } from './requisition-card-actions-modal.component';
import { JobProfileModule } from 'src/app/pages/mission-control-page/job-profile-page/job-profile/job-profile.module';
import { JobLeftModule } from 'src/app/shared/job-left/job-left.module';
import { DoNotHireModule } from 'src/app/shared/do-not-hire/do-not-hire.module';
import { EmailClientReviewModule } from 'src/app/shared/email-client-review/email-client-review.module';

@NgModule({
  declarations: [RequisitionCardActionsModalComponent],
  imports: [
    CommonModule,
    ModalModule.forRoot(),
    JobProfileModule,
    JobLeftModule,
    DoNotHireModule,
    EmailClientReviewModule
  ],
  exports: [RequisitionCardActionsModalComponent],
  entryComponents: [RequisitionCardActionsModalComponent]
})
export class RequisitionCardActionsModalModule { }
